import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils, translate } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import JobHelper from 'utils/jobHelper';
import withRouterHooks from 'utils/routerHelper';
import { isUserReadOnly } from 'utils/accessHelper';
import Detail from './detail';
import CancelSuccessMessage from './cancel/cancelSuccessMessage';

class JobViewForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disableButton: {
        print: false,
      },
      showCancelModal: false,
      showConfirmDuplicateModal: false,
      isJobDuplicating: false,
      isJobDuplicated: false,
    };
  }

  UNSAFE_componentWillMount() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Job.page.loadingItem);
    this.props.dispatch(ReduxActions.job.fetch(Utils.Router.getParams().id))
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _isPointToPoint = () => {
    const { data } = this.props;
    const p2p = data.job_type === 'p2p';

    return p2p || (data.job_type === 'delivery' && data.tags && data.tags.filter(tag => tag.name === 'Point-to-Point').length > 0);
  }

  _viewJobEditForm = () => {
    this.props.navigate(`${Utils.Router.getPath()}/edit`);
  }

  _showDuplicateSuccessMessage = () => {
    Utils.SuccessMessage.SuccessMessageManager.flash((
      <Components.Window.Content
        iconClassName="versa-completed"
      >
        {this.props.strings.Job.page.duplicateSuccess}
        <Components.Link
          onClick={() => {
            Utils.Router.transitionTo(`/submissions/jobs/${this.state.duplicatedJobId}`);
          }}
        >
          {this.props.strings.Job.page.goToDuplicatedJob}
        </Components.Link>
      </Components.Window.Content>
    ), 6000);
  }

  _duplicate = async () => {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.strings.Job.page.duplicatingItem,
    );

    try {
      this.setState({ isJobDuplicating: true });
      const result = await this.props.dispatch(
        ReduxActions.job.duplicate(Utils.Router.getParams().id),
      );

      this.setState({
        showConfirmDuplicateModal: false,
        duplicatedJobId: result.job.id,
        isJobDuplicating: false,
        isJobDuplicated: true,
      }, this._showDuplicateSuccessMessage);

      Utils.FullScreenLoading.FullScreenLoadingManager.close();

      setTimeout(() => this.setState({ isJobDuplicated: false }), 2000);
    } catch {
      Utils.FullScreenLoading.FullScreenLoadingManager.close();
      this.setState({
        showConfirmDuplicateModal: false,
        isJobDuplicating: false,
        isJobDuplicated: false,
      });
      // TODO: Show error message
    }
  };

  _submit() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.data.state === 'rejected'
        ? this.props.strings.Job.page.resubmittingItem
        : this.props.strings.Job.page.submittingItem,
    );
    this.props.dispatch(ReduxActions.job.submit(this.props.data.id))
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _revoke() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.strings.Job.page.retractingItem,
    );
    this.props.dispatch(ReduxActions.job.revoke(this.props.data.id))
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _archive = async () => {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.strings.Job.page.archivingItem,
    );
    await this.props.dispatch(ReduxActions.job.archive(this.props.data.id));
    Utils.FullScreenLoading.FullScreenLoadingManager.close();
  }

  _unarchive = () => {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.strings.Job.page.unarchivingItem,
    );
    this.props.dispatch(ReduxActions.job.unarchive(this.props.data.id))
      .then(() => {
        if (Utils.Helper.isNumber(Utils.Router.getParams().id)) {
          this.props.navigate('/archives/tasks');
        }
      })
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _print = () => {
    JobHelper.print(this.props.data.id);
    this._disableButton('print');
  }

  _cancel() {
    this.setState({ showCancelModal: true });
  }

  _disableButton(buttonName) {
    this.setState(prevState => ({
      disableButton: { ...prevState.disableButton, [buttonName]: true },
    }), async () => {
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.setState(prevState => ({
        disableButton: { ...prevState.disableButton, [buttonName]: false },
      }));
    });
  }

  _isEditable() {
    let isEditable = !isUserReadOnly();
    if (this.props.myjobsSetting) {
      if (['submitted', 'in_progress'].indexOf(this.props.data.state) > -1) {
        isEditable = isEditable && this.props.myjobsSetting.can_edit_after_submission;
      } else if (['completed'].indexOf(this.props.data.state) > -1) {
        isEditable = isEditable && this.props.myjobsSetting.can_edit_after_completion;
      }
    }

    return isEditable;
  }

  async _confirmCancel() {
    const strings = this.props.strings.Job;

    try {
      Utils.FullScreenLoading.FullScreenLoadingManager.open(strings.page.cancellingItem);
      await this.props.dispatch(ReduxActions.job.cancel(this.props.data.id));
      Utils.SuccessMessage.SuccessMessageManager.flash(
        <CancelSuccessMessage count={1} />,
      );

      if (this.props.location.pathname.includes('archives')) {
        this.props.navigate('..', { relative: 'path' });
      } else {
        this.props.navigate('../..', { relative: 'path' });
      }
    } catch (error) {
      Utils.SuccessMessage.SuccessMessageManager.flash(
        <div className="vf-job__cancel-dialog__error-message">
          {Utils.TranslationHelper.replaceTag(strings.cancelDialog.errorMessage, {
            count: 1,
          })}
        </div>,
      );
    }

    this.setState({ showCancelModal: false });
    Utils.FullScreenLoading.FullScreenLoadingManager.close();
  }

  _renderMenu() {
    if (!Utils.Helper.isNullOrUndefined(this.props.data)
      && !Utils.Helper.isNullOrUndefined(this.props.data.customer)) {
      return (
        <Components.Form.Title>
          <Components.Form.Title.Item isHighlighted>
            {this.props.data.customer.name}
          </Components.Form.Title.Item>
        </Components.Form.Title>
      );
    }

    return false;
  }

  _renderSubmissionJobButton() {
    const submitButton = (
      <Components.Form.MainButton
        iconClassName="versa-completed"
        id="vf-job__view-form__right-panel__save-button"
        onClick={() => this._submit()}
      >
        {this.props.data.state === 'rejected'
          ? this.props.strings.Job.form.buttons.resubmit
          : this.props.strings.Job.form.buttons.submit}
      </Components.Form.MainButton>
    );

    const revokeButton = (
      <Components.Button
        iconClassName="versa-retract"
        iconText=""
        id="vf-job__view-form__right-panel__revoke-button"
        onClick={() => this._revoke()}
      >
        {this.props.strings.Job.form.buttons.revoke}
      </Components.Button>
    );

    const stateSubmitted = this.props.data.state === 'submitted' ? revokeButton : submitButton;

    return (
      <Components.Form.RightPanel>
        {this.props.data.state === 'cancelled' ? false : stateSubmitted}
        {this._isEditable() ? (
          <Components.Button
            iconClassName="versa-edit"
            id="vf-job__view-form__right-panel__edit-button"
            onClick={this._viewJobEditForm}
          >
            {this.props.strings.Job.form.buttons.edit}
          </Components.Button>
        ) : false}
        {!isUserReadOnly() ? (
          <Components.Button
            color={this.state.isJobDuplicated
              ? Components.Button.Color.GREEN
              : Components.Button.Color.BLUE}
            iconClassName={this.state.isJobDuplicated ? 'versa-completed' : 'versa-copy'}
            id="vf-job__view-form__right-panel__duplicate-job-button"
            loading={this.state.isJobDuplicating}
            onClick={() => this.setState({ showConfirmDuplicateModal: true })}
          >
            {this.state.isJobDuplicated
              ? this.props.strings.Job.form.buttons.jobDuplicated
              : this.props.strings.Job.form.buttons.duplicate}
          </Components.Button>
        ) : false}
        {
          this.props.data.state !== 'submitted'
          && this.props.data.state !== 'in_progress'
          && this.props.data.state !== 'cancelled'
          && this._isEditable()
          && !this._isPointToPoint()
            ? (
              <Components.Button
                iconClassName="versa-add"
                id="vf-job__view-form__right-panel__new-task-button"
                onClick={() => this.props.navigate(`${Utils.Router.getPath()}/new_task`)}
              >
                {this.props.strings.Job.form.buttons.addTask}
              </Components.Button>
            ) : false
        }
        <Components.Button
          disabled={this.state.disableButton.print}
          iconClassName="versa-print"
          id="vf-job__view-form__right-panel__print-button"
          onClick={this._print}
        >
          {this.props.strings.Job.form.buttons.print}
        </Components.Button>
        {this._isEditable() ? (
          <Components.Archive
            archive={this._archive}
            archivePath={() => this.props.navigate('/archives/jobs')}
            ids={[this.props.data.id]}
            modelName={this.props.strings.Job.constants.job}
            updateContent={() => {
              this.props.dispatch(ReduxActions.job.fetchList());
              if (this.props.location.pathname.includes('archives')) {
                this.props.navigate('..', { relative: 'path' });
              } else {
                this.props.navigate('../..', { relative: 'path' });
              }
            }}
          >
            <Components.Button
              iconClassName="versa-archive"
              iconText=""
              id="vf-job__view-form__right-panel__archive-button"
            >
              {this.props.strings.Job.form.buttons.archive}
            </Components.Button>
          </Components.Archive>
        ) : false}
        {this._isEditable() && this.props.data.cancellable
          && ['draft', 'submitted', 'rejected'].indexOf(this.props.data.state) > -1
          ? (
            <Components.Button
              iconClassName="versa-danger"
              id="vf-job__view-form__right-panel__cancel-button"
              onClick={() => this._cancel()}
            >
              {this.props.strings.Job.form.buttons.cancel}
            </Components.Button>
          ) : false}
      </Components.Form.RightPanel>
    );
  }

  _renderInProgressJobButton() {
    return (
      <Components.Form.RightPanel>
        {this._isEditable() ? (
          <Components.Button
            iconClassName="versa-edit"
            id="vf-job__view-form__right-panel__edit-button"
            onClick={this._viewJobEditForm}
          >
            {this.props.strings.Job.form.buttons.edit}
          </Components.Button>
        ) : false}
        {!isUserReadOnly() ? (
          <Components.Button
            color={this.state.isJobDuplicated
              ? Components.Button.Color.GREEN
              : Components.Button.Color.BLUE}
            iconClassName={this.state.isJobDuplicated ? 'versa-completed' : 'versa-copy'}
            id="vf-job__view-form__right-panel__duplicate-job-button"
            loading={this.state.isJobDuplicating}
            onClick={() => this.setState({ showConfirmDuplicateModal: true })}
          >
            {this.state.isJobDuplicated
              ? this.props.strings.Job.form.buttons.jobDuplicated
              : this.props.strings.Job.form.buttons.duplicate}
          </Components.Button>
        ) : false}
        <Components.Button
          disabled={this.state.disableButton.print}
          iconClassName="versa-print"
          id="vf-job__view-form__right-panel__print-button"
          onClick={this._print}
        >
          {this.props.strings.Job.form.buttons.print}
        </Components.Button>
        {(this._isEditable() && this.props.data.cancellable
          && ['draft', 'submitted', 'rejected'].indexOf(this.props.data.state) > -1)
          ? (
            <Components.Button
              iconClassName="versa-danger"
              id="vf-job__view-form__right-panel__cancel-button"
              onClick={this._cancel}
            >
              {this.props.strings.Job.form.buttons.cancel}
            </Components.Button>
          ) : false}
      </Components.Form.RightPanel>
    );
  }

  _renderArchivedJobButton() {
    return (
      <Components.Form.RightPanel>
        {this._isEditable() ? (
          <Components.Unarchive
            id="vf-job__view-form__right-panel__unarchive-button"
            modelName={this.props.strings.Job.constants.job}
            onClick={this._unarchive}
            withDefaultText
          />
        ) : false}
        <Components.Button
          disabled={this.state.disableButton.print}
          iconClassName="versa-print"
          id="vf-job__view-form__right-panel__print-button"
          onClick={this._print}
        >
          {this.props.strings.Job.form.buttons.print}
        </Components.Button>
      </Components.Form.RightPanel>
    );
  }

  _renderRightPanel() {
    if (this.props.data.archived) {
      return this._renderArchivedJobButton();
    }

    if (this.props.data.state === 'in_progress' || this.props.data.state === 'completed') {
      return this._renderInProgressJobButton();
    }

    return this._renderSubmissionJobButton();
  }

  _renderConfirmDuplicateModal() {
    const strings = this.props.strings.Job.duplicateDialog;

    return (
      <Components.Modal.Warning
        headerText={strings.header}
        leftButtonOnClick={this._duplicate}
        leftButtonText={strings.confirmButton}
        rightButtonOnClick={() => this.setState({ showConfirmDuplicateModal: false })}
        rightButtonText={strings.cancelButton}
        visible={this.state.showConfirmDuplicateModal}
      >
        {strings.description}
      </Components.Modal.Warning>
    );
  }

  _renderCancelModal() {
    const strings = this.props.strings.Job.cancelDialog;

    return (
      <Components.Modal.Warning
        headerText={strings.header}
        leftButtonOnClick={() => this._confirmCancel()}
        leftButtonText={strings.confirmButton}
        rightButtonOnClick={() => this.setState({ showCancelModal: false })}
        rightButtonText={strings.cancelButton}
        visible={this.state.showCancelModal}
      >
        {strings.line1}
        <br />
        <br />
        {strings.line2}
      </Components.Modal.Warning>
    );
  }

  render() {
    if (Utils.Helper.isNullOrUndefined(this.props.data)) {
      return false;
    }

    return (
      <Components.Form.CoreLayout
        onClose={() => (this.props.location.pathname.includes('archives')
          ? this.props.navigate('..', { relative: 'path' })
          : this.props.navigate('../..', { relative: 'path' }))}
        rightPanel={this._renderRightPanel()}
        title={this._renderMenu()}
      >
        <Detail data={this.props.data} id="vf-job__view-form__left-panel" />
        {this._renderCancelModal()}
        {this._renderConfirmDuplicateModal()}
      </Components.Form.CoreLayout>
    );
  }
}

JobViewForm.displayName = 'Job View Form';

JobViewForm.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    job_type: PropTypes.string,
    state: PropTypes.string,
    archived: PropTypes.bool,
    cancellable: PropTypes.bool,
    customer: PropTypes.shape({
      name: PropTypes.string,
    }),
    tags: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  myjobsSetting: PropTypes.shape({
    can_edit_after_completion: PropTypes.bool,
    can_edit_after_submission: PropTypes.bool,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      constants: PropTypes.shape({
        job: PropTypes.string,
      }),
      page: PropTypes.shape({
        loadingItem: PropTypes.string,
        resubmittingItem: PropTypes.string,
        submittingItem: PropTypes.string,
        retractingItem: PropTypes.string,
        archivingItem: PropTypes.string,
        unarchivingItem: PropTypes.string,
        cancellingItem: PropTypes.string,
        duplicatingItem: PropTypes.string,
        duplicateSuccess: PropTypes.string,
        goToDuplicatedJob: PropTypes.string,
      }),
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          duplicate: PropTypes.string,
          jobDuplicated: PropTypes.string,
          resubmit: PropTypes.string,
          submit: PropTypes.string,
          revoke: PropTypes.string,
          edit: PropTypes.string,
          addTask: PropTypes.string,
          archive: PropTypes.string,
          cancel: PropTypes.string,
          unarchive: PropTypes.string,
          print: PropTypes.string,
        }),
      }),
      duplicateDialog: PropTypes.shape({
        header: PropTypes.string,
        description: PropTypes.string,
        cancelButton: PropTypes.string,
        confirmButton: PropTypes.string,
      }),
      cancelDialog: PropTypes.shape({
        header: PropTypes.string,
        confirmButton: PropTypes.string,
        cancelButton: PropTypes.string,
        line1: PropTypes.string,
        line2: PropTypes.string,
        errorMessage: PropTypes.string,
      }),
    }),
  }).isRequired,
};

function mapStateToProps(state, ownProps) {
  const { job, profile } = state;
  return {
    data: job.jobs[ownProps.params.id],
    myjobsSetting: (profile.profile || {}).myjobs_setting,
  };
}

export default withRouterHooks(connect(mapStateToProps)(translate('')(JobViewForm)));
